import React from 'react';
export function FinalCTA() {
  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-14 bg-[#1e3a5f] text-white text-center relative overflow-hidden" data-id="element-32">
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-60 h-60 rounded-full bg-[#d4a017] opacity-5 blur-3xl" data-id="element-33"></div>
      <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-60 h-60 rounded-full bg-blue-400 opacity-5 blur-3xl" data-id="element-34"></div>

      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-35">
        <h2 className="text-2xl md:text-3xl font-bold italic mb-8 leading-tight text-white/95" style={{
        fontFamily: "'Playfair Display', serif"
      }} data-id="element-36">
          Hacé clic y empezá hoy.
        </h2>

        <a href="Link de tu checkout" onClick={scrollToPricing} className="inline-flex items-center justify-center bg-[#d4a017] hover:bg-[#e5b229] text-[#1e3a5f] font-extrabold text-base md:text-lg tracking-wider uppercase px-10 md:px-14 py-4 md:py-5 rounded-full transition-all duration-200 shadow-[0_4px_20px_rgba(212,160,23,0.35)] hover:-translate-y-0.5" data-id="element-37">
          ACCEDER AHORA &nbsp;→
        </a>
      </div>
    </section>;
}